import { ParsedError } from './ParsedError'

export class FrameworkError extends ParsedError {
  override readonly tag = 'nuxt'

  override readonly attributes

  constructor(
    statusCode: number | undefined,
    statusMessage: string | undefined,
    customAttributes: Record<string, unknown>,
  ) {
    super()
    this.attributes = {
      ...customAttributes,
      statusCode,
      statusMessage,
    }
  }
}
